import React from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalBalance.module.scss";
import Button from "../../ui/Button/Button";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../context/ModalBalanceContext";

export const ModalBalance = ({ visible, setVisible }) => {
  const navigate = useNavigate();
  const { setIsModalBalanceVisible } = useModal();

  const handleGoToPayment = () => {
    navigate("/wallet?pay=true");
    setIsModalBalanceVisible(false);
  };

  return (
    <Modal visible={visible} handleClose={() => setVisible(false)}>
      <div className={styles.container}>
        <div className={styles.title}>На вашем счету недостаточно средств!</div>
        <div className={styles.description}>
          Для продолжения использования услуг пополните счет. Обратите внимание,
          что доступ к услугам будет временно приостановлен до момента оплаты.
        </div>
        <Button
          onClick={handleGoToPayment}
          className={styles.button}
          title={"Перейти к оплате"}
        />
      </div>
    </Modal>
  );
};
